import urls from "../urls";
import {isLegacyOrigin, isShift4Origin} from "../securionpayOrigins";
import {GATEWAY_URL, SHIFT4_GATEWAY_URL} from "../env";

const getGatewayUrlBasedOnIframeLocation = () => {
    const windowOrigin = urls.getOrigin(window.location.href);
    if (isLegacyOrigin(windowOrigin)) {
        return GATEWAY_URL
    }
    if (isShift4Origin(windowOrigin)) {
        return SHIFT4_GATEWAY_URL
    }
    throw new Error("Script loaded from invalid origin.")
}


export const GATEWAY_URL_BASED_ON_IFRAME_LOCATION = getGatewayUrlBasedOnIframeLocation()